import React, { createContext, useContext, useMemo } from "react";
import ec from "./ec.json";
import en from "./en.json";

const DICTS = { ec, en };
const I18nContext = createContext({ lang: "ec", t: (k) => k, dict: ec });

const resolve = (dict, path) => {
  const parts = path.split(".");
  let cur = dict;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
};

export const I18nProvider = ({ lang, children }) => {
  const safeLang = DICTS[lang] ? lang : "ec";
  const dict = DICTS[safeLang];
  const value = useMemo(
    () => ({
      lang: safeLang,
      dict,
      t: (key, fallback) => {
        const v = resolve(dict, key);
        if (v === undefined || v === null) return fallback ?? key;
        return v;
      },
    }),
    [safeLang, dict]
  );
  return React.createElement(I18nContext.Provider, { value }, children);
};

export const useI18n = () => useContext(I18nContext);
